import { getPostCategories } from '../../../application/pageDataObject'
import { register } from '../../../../components/viewability/viewbilityTracker'
import { dispatch } from '../../../application/appStore'
import { widgetEmbedEvent } from '../../actions/analyticsActions'

const copyAttributes = (elemFrom, elemTo) =>
  Array.from(elemFrom.attributes).forEach(attr => elemTo.setAttribute(attr.name, attr.value))

const convertToExecutableScripts = scripts => {
  return scripts.map(script => {
    const executable = document.createElement('script')
    executable.innerHTML = script.innerHTML ? script.innerHTML : ''
    copyAttributes(script, executable)
    return executable
  })
}

const isJS = script => script.type === '' || script.type.indexOf('javascript') >= 0

const findJavaScriptElements = wrapper => {
  const scripts = Array.from(wrapper.getElementsByTagName('script'))
  return scripts.filter(isJS)
}

const removeScripts = scripts => {
  scripts.forEach(script => script.remove())
}

const wrapHTML = html => {
  const tempWrapper = window.parent.document.createElement('div')
  tempWrapper.innerHTML = html
  return tempWrapper
}

export const generateInsertableHTML = html => {
  const wrapper = wrapHTML(html)
  const scripts = findJavaScriptElements(wrapper)
  // Remove injected scripts and leave only created executable scripts
  removeScripts(scripts)
  const elements = Array.from(wrapper.childNodes)
  return {
    elements,
    scripts: convertToExecutableScripts(scripts),
  }
}

export const generateEmbedContent = data => {
  const { elements, scripts } = data
  const el = document.createElement('div')
  el.style.width = '100%'
  elements.forEach(elem => {
    el.appendChild(elem)
  })
  scripts.forEach(script => {
    el.appendChild(script)
  })
  return el
}

export const postHasAtLeastParagraphs = minimumParagraphs => {
  const initialParagraphs = document.querySelectorAll('.post-content > p').length
  const emptyParagraphs = document.querySelectorAll('.post-content > p > br').length
  return initialParagraphs - emptyParagraphs > minimumParagraphs
}

export const postCategoriesAllowCampaigns = () => {
  const postCategories = getPostCategories()
  return !postCategories.includes('no-campaign-manager') && !postCategories.includes('sponsored')
}

const isParagraph = node => {
  const nodeHTML = node.innerHTML
  const isBoldTitle = nodeHTML.match(`<strong>.+<\\/strong>`) !== null
  return (
    node.innerText !== '' &&
    nodeHTML !== '<span style="font-size: 1em;"><br></span>' &&
    nodeHTML !== '<strong><br></strong>' &&
    !isBoldTitle &&
    nodeHTML !== '&nbsp;'
  )
}

export const getPostItems = () => [...document.querySelectorAll('.post-content > *')]

export const findPositionToInjectCampaign = () => {
  const postItems = getPostItems()
  const isParagraphArray = postItems.map(x => isParagraph(x))
  const startPoint = parseInt(isParagraphArray.length / 2, 10)
  for (let i = startPoint; i < isParagraphArray.length - 2; i++) {
    if (isParagraphArray[i] && isParagraphArray[i + 1]) {
      return i
    }
  }
  return -1
}

export const findPositionToInjectCampaignEs = () => {
  const postItems = getPostItems()
  const isParagraphArray = postItems.map(x => isParagraph(x))
  const startPoint = parseInt(isParagraphArray.length, 1)
  for (let i = startPoint; i < isParagraphArray.length - 2; i++) {
    if (isParagraphArray[i]) {
      return i
    }
  }
  return -1
}

export const generateCampaignElement = script => {
  const parsedScript = generateInsertableHTML(`${script}`)
  return generateEmbedContent(parsedScript)
}

export const registerElementToViewabilityTracker = element => {
  register(`.${element.className}`)
}

export const dispatchWidgetEmbed = (element, viewabilityLabel) => {
  dispatch(widgetEmbedEvent(element.getAttribute(viewabilityLabel)))
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/campaigns/initCampaigns.utils.js